import { ref } from 'vue';

/**
 *
 * @param {Object} options
 * @param {String} options.mode 'dec' | 'inc'
 * @param {Boolean} options.incOnZero  是否在倒计时为0时重置
 * @returns
 */
export const useCounter = (incOnZero = false) => {
  const count = ref(0);
  const currentMode = ref();
  let timer = null;

  const handleDecrement = () => {
    count.value--;
    if (count.value === 0) {
      if (incOnZero) {
        currentMode.value = 'inc';
      } else {
        pause();
      }
    }
  };

  const handleIncrement = () => {
    count.value++;
  };

  const start = (startTime) => {
    if (timer) return;
    count.value = Math.abs(startTime);
    currentMode.value = startTime < 0 ? 'dec' : 'inc';
    timer = setInterval(() => {
      if (currentMode.value === 'dec') {
        handleDecrement();
      } else if (currentMode.value === 'inc') {
        handleIncrement();
      }
    }, 1000);
  };

  const pause = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  const resume = () => {
    if (!timer) {
      timer = setInterval(() => {
        if (currentMode.value === 'dec') {
          handleDecrement();
        } else if (currentMode.value === 'inc') {
          handleIncrement();
        }
      }, 1000);
    }
  };

  return { count, start, pause, resume };
};
